import React, {
  forwardRef,
  useImperativeHandle,
  useEffect,
  useState,
  // useMemo,
} from 'react'

import {
  StyleSheet,
  // Text,
  // TouchableOpacity,
  View,
  // Image,
  // TouchableOpacity,
} from 'react-native'
import PropTypes from 'prop-types'
import Summary from '@components/chipscontrol/summary'
import BtnToggleCash from '@components/chipscontrol/BtnToggleCash'
import CashInputSlider from '@screens/base/cashinputslider'
import ChipInputSlider from '@screens/base/chipinputslider'
import Constants from '@constants'
import Button from '@components/button'

import Styles, { CommonStyle as cs, scaleSize } from '@styles'
const { SC, Colors } = Styles

const SliderPanel = forwardRef((props, ref) => {
  const {
    chip,
    onChipChangeValue,
    onEnter,
    onEnterDisabled,
    onReset,
    isCashMode,
    noCashToggle,
    noButtons,
    totalChipAmount,
    min = 0,
    max = 100,
    prependButton,
    appendButton,
    summary,
    disabled,
    sliderWidth,
    stylePanel,
  } = props

  const [showCashSlider, setShowCashSlider] = useState(false)
  const [totalCashAmount, setTotalCashAmount] = useState(0)
  const [cash, setCash] = useState({
    value: Constants.CASH_CONST,
    min: Constants.CASH_MIN,
    max: Constants.CASH_MAX,
    count: 0,
  })
  const [_sliderWidth, setSliderWidth] = useState(sliderWidth)
  useEffect(() => {
    let swidth = 80 // default slider width
    if (sliderWidth != null) {
      swidth = sliderWidth
    }
    setSliderWidth(swidth)
  }, [sliderWidth])

  useImperativeHandle(ref, () => ({
    toggleShowCash: (showCash) => { setShowCashSlider(showCash) },
  }))

  useEffect(() => {
    if (isCashMode) {
      setShowCashSlider(false)
    }
  }, [isCashMode])

  const onCashChange = (cash, count) => {
    cash.count = count
    setCash({ ...cash })
    setTotalCashAmount(cash.count)
  }

  const onLocalReset = () => {
    cash.count = 0
    setCash({ ...cash })
    setTotalCashAmount(cash.count)
    onReset?.()
  }

  return (<View style={[styles.container, stylePanel, cs.roundedEnd, cs.pa]}>
    <View style={[styles.containerInner]}>
      {
        !isCashMode && !noCashToggle ?
          <View style={{ width: '100%' }}>
            <BtnToggleCash
              isToggle={showCashSlider}
              onPress={() => setShowCashSlider(!showCashSlider)}
            />
          </View> : null
      }
      {
        (!showCashSlider || isCashMode) && chip &&
        <View>
          <ChipInputSlider
            width={_sliderWidth}
            chip={chip}
            min={0}
            max={100}
            onChangeValue={onChipChangeValue}
            isCashMode={isCashMode}
          />
        </View>
      }
      {
        showCashSlider &&
        <View>
          <CashInputSlider
            width={_sliderWidth}
            chip={cash}
            min={min}
            max={max}
            onChangeValue={onCashChange}
          />
        </View>
      }
    </View>
    <View>
      {summary?.({
        total_cash_amount: totalCashAmount,
        total_chip_amount: totalChipAmount,
      })}
      {!summary && <Summary
        totalCashAmount={totalCashAmount}
        totalChipAmount={totalChipAmount}
      />}
      {prependButton}
      {
        !noButtons ?
          <View style={[{ flexDirection: 'row', paddingTop: scaleSize(5) }]}>
            <Button
              title="Reset"
              disabled={disabled || false}
              onPress={onLocalReset}
              style={[styles.button, styles.buttonReset]} />
            <Button
              title="Enter"
              disabled={disabled || (onEnterDisabled ? onEnterDisabled() : false)}
              onPress={onEnter}
              style={styles.button} />
          </View> : null
      }
      {appendButton}
    </View>
  </View>)
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: Colors.DASH_MAIN,
    marginStart: scaleSize(3),
    // paddingVertical: scaleSize(10),
    // paddingHorizontal: scaleSize(10),
  },
  containerInner: {
    alignItems: 'center',
    paddingTop: scaleSize(5)
    // justifyContent: 'center',
  },
  buttonReset: {
    backgroundColor: Colors.BUTTON_RESET,
    marginRight: SC.GAP_S * SC.SCALE,
  },
  button: {
    flex: 1,
    backgroundColor: Colors.BUTTON_WIZ,
  },
})

SliderPanel.displayName = 'SliderPanel'

SliderPanel.propTypes = {
  chip: PropTypes.any.isRequired,
  onChipChangeValue: PropTypes.func.isRequired,
  onEnter: PropTypes.func.isRequired,
  onEnterDisabled: PropTypes.func,
  onReset: PropTypes.func.isRequired,
  isCashMode: PropTypes.bool,
  noCashToggle: PropTypes.bool,
  noButtons: PropTypes.bool,
  totalChipAmount: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  prependButton: PropTypes.element,
  appendButton: PropTypes.element,
  summary: PropTypes.func,
  disabled: PropTypes.bool,
  sliderWidth: PropTypes.number,
  stylePanel: PropTypes.any,
}

export default SliderPanel